// loadUrlQueryAction.js
'use strict';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import login from '../action/login.js';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import updateLoginData from '../action/updateLoginData.js';
import sendEmailOtp from '../action/sendEmailOtp.js';
import sendCheckAcquisitionCode from '../action/sendCheckAcquisitionCode.js';
import addJob from '../action/addJob.js';
import transitLoginViewStatus from '../action/transitLoginViewStatus.js';
import { login as loginModal } from '../resource/modalId.js';
import { JOB_TYPE } from '../resource/jobConstants.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { ACQUISITION_TYPES_PREPAID_CARD } from '../RemoteConfigKeys.js';
import { getSearchParams } from '../resource/getSearchParams.js';
import addPendingRemoveSearchParams from '../action/addPendingRemoveSearchParams.js';
import { EmailTemplate } from '../resource/authEntryType.js';

/**
 * Load url query action
 * @kind action
 * @param {URLSearchParams} {searchParams} - action param.
 * @return {Promise} Action promise.
 */
const loadUrlQueryAction =
  ({ searchParams }) =>
  async (dispatch, getState) => {
    /// sometimes we have url length limit. (ex: verotel)
    const action = searchParams.get('action') || searchParams.get('act');
    switch (action) {
      case 'login': {
        const token = getMeData(getState(), 'token');
        if (token) {
          return dispatch({ type: '' });
        }
        dispatch(login());
        dispatch(
          addPendingRemoveSearchParams({ queryKeys: ['action', 'act'] })
        );
        return dispatch({ type: '' });
      }
      case 'login-with-email': {
        const email = getSearchParams({ queryKey: 'login-email' });
        if (!email) {
          return dispatch({ type: '' });
        }

        const token = getMeData(getState(), 'token');
        if (!token) {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: { selectPath: ['login'], data: { entry: 'register' } },
          });
          dispatch(updateLoginData({ dataKey: 'email', value: email }));
          dispatch(
            addModal({
              id: loginModal.EMAIL,
              transitionStatus: 'opening',
              isHigherThanAll: true,
            })
          );
        }

        dispatch(
          addPendingRemoveSearchParams({
            queryKeys: ['action', 'act', 'login-email'],
          })
        );

        return dispatch({ type: '' });
      }
      case 'showNotificationTutorial': {
        await navigator.serviceWorker.ready;
        dispatch(addModal({ id: 'NotificationAsker', isHigherThanAll: true }));

        dispatch(
          addPendingRemoveSearchParams({ queryKeys: ['action', 'act'] })
        );
        return dispatch({ type: '' });
      }
      case 'add-credit-card': {
        dispatch(
          removeModals({
            ids: [
              'VerifyFreeUserModal',
              'TappayAddNewCardModal',
              'SecurionpayAddNewCardModal',
            ],
          })
        );
        return dispatch(
          addPendingRemoveSearchParams({ queryKeys: ['action', 'act'] })
        );
      }
      case 'prepaid': {
        const orderId = searchParams.get('order');
        if (!orderId) {
          return dispatch({ type: '' });
        }

        const code = `order-${orderId}`;
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: { selectPath: ['acquisition', 'prepaid'], data: { code } },
        });

        // might not have user id yet.
        const hasToken = !!getMeData(getState(), 'token');
        const email = getSearchParams({ queryKey: 'email' });
        if (hasToken) {
          dispatch(
            sendCheckAcquisitionCode({
              code,
              acquisitionTypes: getRemoteConfigData(
                getState(),
                ACQUISITION_TYPES_PREPAID_CARD
              ),
            })
          );
        } else if (email) {
          // Will use code in action/fetchFlightCheck().
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: { selectPath: ['login'], data: { entry: 'register' } },
          });
          dispatch(updateLoginData({ dataKey: 'email', value: email }));
          dispatch(
            sendEmailOtp({
              email,
              from: 'null',
              entry: 'register',
              templateId: EmailTemplate.SIGNUP,
            })
          );
        }

        dispatch(
          addPendingRemoveSearchParams({
            queryKeys: ['action', 'act', 'email', 'order'],
          })
        );

        return dispatch({ type: '' });
      }
      // handle checkout diamondpack. codp := checkout-diamondpack
      case 'codp': {
        const productIds = searchParams.getAll('p_id');
        const email = getSearchParams({ queryKey: 'email' });
        const via = 'campaign';
        const recommendProductId = productIds[0];

        dispatch(
          addJob({
            jobType: JOB_TYPE.checkoutDiamondPack,
            selectPath: ['job', 'flightCheck', 'succeed'],
            payload: {
              productIds,
              via,
              recommendProductId,
            },
          })
        );

        if (email) {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: { selectPath: ['login'], data: { entry: 'register' } },
          });
          dispatch(updateLoginData({ dataKey: 'email', value: email }));
          dispatch(transitLoginViewStatus({ from: 'null', to: 'emailVerify' }));
        }
        dispatch(
          addPendingRemoveSearchParams({
            queryKeys: ['action', 'act', 'email', 'p_id'],
          })
        );
        return dispatch({ type: '' });
      }
      default:
        return dispatch({ type: '' });
    }
  };

export default loadUrlQueryAction;
